import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import keycloak from '../keycloak';
import { PRODUCTION } from '../global';
import { AssistantModal } from '../shadcnComponents/assistant-ui/assistant-modal'
import './chatbot.css'
import { SidebarProvider, SidebarTrigger } from '../shadcnComponents/ui'
import { GeneralSideBar } from './generalSidebar';
import { JustrediLoader } from './justrediLoader';
import { UserContext } from '../contextProvider';
import justrediLogo from "./justredi-logo.png"
import ministryLogo from "./mindev-logo.png"
import ggekLogo from "./ggek_logo.png"
import greece20Logo from "./Greece_2.0_NextGeneration_gr_1.jpg"
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

function Layout({ authenticated, sidebar, children }) {
  const { setUserInfo } = useContext(UserContext);
  const [groupManager, setGroupManager] = useState(false)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate();
  const [sidebarVisible, setSidebarVisible] = useState(true)
  const handleLogout = () => {
    keycloak.logout({ redirectUri: PRODUCTION ? "https://apps.ilsp.gr/justredi/" : 'https://chomsky.ilsp.gr:3003/justredi/' })
      .then(() => {
        localStorage.removeItem('justredi_token')
        localStorage.removeItem('justredi_refreshToken')
        localStorage.removeItem('justredi_idToken')
        localStorage.removeItem('interviewId')
        navigate('/home');
      });
  };

  useEffect(() => {
    async function getInfo() {
      const info = await keycloak.loadUserInfo().then(info => info, error => {
        console.error('Got an error on getInfo')
        setLoading(false);
        keycloak.logout({ redirectUri: PRODUCTION ? "https://apps.ilsp.gr/justredi/login" : 'https://chomsky.ilsp.gr:3003/justredi/login' })
          .then(() => {
            console.error('Got an error on getInfo')
            localStorage.removeItem('justredi_token')
            localStorage.removeItem('justredi_idToken')
            localStorage.removeItem('user')
          });
      });
      if (info && info.resource_access && setUserInfo) {
        Object.values(info.resource_access).map(each => { if (each.roles[0] == 'Group Manager') { setGroupManager(true) } })
        localStorage.setItem('user', JSON.stringify(info))
        setUserInfo(info);
        setLoading(false)
      } else {
        console.log(info)
      }
    }
    if (keycloak.authenticated) {
      getInfo();
    } else {
      setLoading(false);
      navigate('/login')
    }
  }, []);

  return (
    <div className="h-screen w-screen select-none">
      {loading ?
        <JustrediLoader />
        :
        <div className="flex flex-col h-full w-full">
          <QuestionMarkCircleIcon onClick={() => { navigate('/instructions') }} color={'var(--muted-foreground)'} className='hover:text-primary cursor-pointer absolute right-4 top-[74px] h-8' />
          <header id='header' className="bg-primary text-primary-foreground pl-4 flex flex-row items-center h-[58px] min-h-[58px] max-h-[58px] max-w-full w-full">
            <h1 className="text-xl font-bold mr-auto cursor-default flex flex-row items-end w-full pr-8">
              <span className='mr-auto text-xl my-auto h-fit'>Justredi Trancript Editor</span>
              <img src={justrediLogo} className='h-[50px]' />
            </h1>
          </header>
          {/* Main content */}
          <main className="max-w-full w-full h-[calc(100%-122px)] flex my-auto overflow-y-auto">
            <SidebarProvider className='h-full w-full'>
              {sidebar && <GeneralSideBar handleLogout={handleLogout} admin={groupManager} />}
              <div className={`flex flex-row ${sidebar && sidebarVisible ? 'w-[calc(100%-20rem)]' : 'w-full  delay-150'} transition-[width] duration-200 ease-out`}>
                {sidebar &&
                  <div className='w-fit pt-4 px-2'>
                    <SidebarTrigger onClick={() => { setSidebarVisible(!sidebarVisible) }} />
                  </div>
                }
                {children}
              </div>
            </SidebarProvider>
          </main>
          {localStorage.getItem('user') && authenticated &&
            <AssistantModal />
          }
          {/* Footer */}
          <footer className="bg-primary text-primary-foreground h-[64px] min-h-[64px] max-h-[64px] flex pl-4 items-center gap-2 max-w-full w-full">
            {/* <div className="text-start mr-auto h-full flex items-center justify-center cursor-default text-sm">
              <p>
                &copy;
                {new Date().getFullYear()}
                {' '}
                Justredi Transcript Editor
              </p>
            </div> */}
            <span className="text-[0.7rem] my-auto ml-auto w-fit">
              <a className="w-fit" href='privacy_terms' target="_blank"><u><p className='text-nowrap'>Όροι χρήσης</p><p className='text-nowrap'>& Πολιτική Απορρήτου</p></u></a>
            </span>
            <div className='border-r border-ring h-1/2 my-auto' />
            <span className='text-[0.7rem] cursor-default h-fit my-auto min-w-0 line-clamp-3'>
              Δράση ενίσχυσης επενδύσεων «Εμβληματικές δράσεις σε διαθεματικές επιστημονικές περιοχές με ειδικό ενδιαφέρον για την σύνδεση με τον παραγωγικό ιστό» / Ανθεκτικότητα, Συμπερίληψη και Ανάπτυξη: Προς μια Δίκαιη Πράσινη και Ψηφιακή Μετάβαση των Ελληνικών Περιφερειών – TAEDR-0537352. Η δράση υλοποιείται στο πλαίσιο του Εθνικού Σχεδίου Ανάκαμψης και Ανθεκτικότητας Ελλάδα 2.0 με τη χρηματοδότηση της Ευρωπαϊκής Ένωσης – NextGenerationEU.
            </span>
            <div className='flex flex-row bg-white pr-2 mr-auto min-w-fit gap-1 h-full'>
              <img src={ministryLogo} className='h-inherit' />
              <img src={ggekLogo} className='h-inherit' />
              <img src={greece20Logo} className='h-inherit' />
            </div>
          </footer>
        </div>
      }
    </div>
  );
}

export default Layout;